
import { defineComponent } from "vue";
import homeConnectTestnetWalletComponent from '@/modules/home/components/homeConnectTestnetWalletComponent.vue';
import homeConnectMainnetWalletComponent from '@/modules/home/components/homeConnectMainnetWalletComponent.vue';
import store from "@/store/index";

export default defineComponent({
  name: "viewHomeSettings",
  components: {
    homeConnectTestnetWalletComponent,
    homeConnectMainnetWalletComponent,
  },

  data: function () {
    return {
      q1: false,
      q2: false,
      q3: false,
      q4: false,
      currentOpenedTab: 'testnet',
    };
  },

  computed: {
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    enableMainnet() {
      return store.getters['config/getEnableMainnet'];
    }
  },
});
